import React, { useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import Tooltip from '@material-ui/core/Tooltip'
import Divider from '@material-ui/core/Divider'

import ScrollUp from '../../../assets/scrollUp.png'
import ScrollDown from '../../../assets/scrollDown.png'

import { setSideBarInfo } from 'store/global/map/sideBarInfo'

import './SideBar.css'

function SideBar(props) {
  const dispatch = useDispatch()
  const [scroll, setScroll] = useState(false)
  // const [arrowUp, setArrowUp] = useState('0.10')
  const [arrowUp, setArrowUp] = useState('0.54')
  const [arrowDown, setArrowDown] = useState('0.54')

  useEffect(() => {
    // console.log("props.sidebarData: ", props.sidebarData)

    const height = document.getElementsByClassName('sb-container')[0].clientHeight
    if (height > 460 && window.innerHeight <= 760) {
      // document.getElementById("sb-c").scrollBy(0, -500)
      document.getElementById('sb-c').style.maxHeight = '356px'
      setScroll(true)
    }
  }, [])

  const updateFieldChanged = (data, index) => (e) => {
    let newArr = [...props.sidebarData]
    // console.log(newArr.filter(val=> val.title === data.title)[0])
    for (var i = 0; i < props.sidebarData.length; i++) {
      if (i == index) {
        newArr[index].show = !data.show
      } else {
        newArr[i].show = false
      }
    }
    props.setSidebarData(newArr)
    let currentSidebarJSON = JSON.parse(JSON.stringify(props.sidebarData))
    let currentSidebar = [...currentSidebarJSON]
    dispatch(setSideBarInfo(currentSidebar))
    props.setLayer(index)
  }
  // console.log(props.sidebarData)
  const scrollDown = () => {
    if (document.getElementById('sb-c').scrollTop !== 99) document.getElementById('sb-c').scrollBy(0, 50)
    // if (document.getElementById('sb-c').scrollTop === 153) {
    //   setArrowDown('0.10')
    //   setArrowUp('0.54')
    // }
    // document.getElementById("sb-c").scrollBy(0, 50);
  }

  const scrollUp = () => {
    if (document.getElementById('sb-c').scrollTop !== 0) document.getElementById('sb-c').scrollBy(0, -50)
    // if (document.getElementById('sb-c').scrollTop === 0) {
    //   setArrowUp('0.10')
    //   setArrowDown('0.54')
    // }
    // document.getElementById("sb-c").scrollBy(0, -50);
  }

  const scrolling = () => {
    // console.log(document.getElementById("sb-c").scrollTop)
    // if (document.getElementById('sb-c').scrollTop === 153) {
    //   setArrowDown('0.10')
    //   setArrowUp('0.54')
    // }
    // if (document.getElementById('sb-c').scrollTop === 0) {
    //   setArrowUp('0.10')
    //   setArrowDown('0.54')
    // }
    // document.getElementById("sb-c").scrollBy(0, -50);
  }

  return (
    <div className="side-bar-mc">
      {scroll ? (
        <button
          type="button"
          className="sb-item"
          onClick={() => scrollUp()}
          style={{ borderBottom: '1px solid #d9d9d9', borderRadius: '5px 5px 0px 0px' }}
        >
          <img
            src={ScrollUp}
            className="icon-align-inf"
            style={{ height: '100%', width: '100%', opacity: `${arrowUp}` }}
          />
        </button>
      ) : null}
      <div className="sb-container" id="sb-c" onScroll={() => scrolling()}>
        {props.sidebarData.map((data, index) =>
          data.title === 'Download Request' ? null : (
            <div>
              <Tooltip title={data.title} placement="right" arrow>
                {data.show ? (
                  <button
                    type="button"
                    className="sb-item"
                    style={{ backgroundColor: '#d4d9df' }}
                    onClick={updateFieldChanged(data, index)}
                  >
                    <img src={data.icon} className="icon-align-inf" />
                  </button>
                ) : (
                  <button type="button" className="sb-item" onClick={updateFieldChanged(data, index)}>
                    <img src={data.icon} className="icon-align-inf" />
                  </button>
                )}
              </Tooltip>

              <Divider />
            </div>
          ),
        )}
      </div>
      {scroll ? (
        <button
          type="button"
          className="sb-item"
          onClick={() => scrollDown()}
          style={{ borderTop: '1px solid #d9d9d9', borderRadius: '0px 0px 5px 5px' }}
        >
          <img
            src={ScrollDown}
            className="icon-align-inf"
            style={{ height: '100%', width: '100%', opacity: `${arrowDown}` }}
          />
        </button>
      ) : null}
    </div>
  )
}

export default SideBar
